import { SiteSettings } from "../shared/SiteSettings";
import { singleton } from "tsyringe";

@singleton()
export class ToutvSiteSettings implements SiteSettings {
  get BlueConicProductionHostName(): string {
    return "cdp.tou.tv";
  }

  get CookiesDomain(): string {
    return ".tou.tv";
  }

  get ProductionHostNames(): string[] {
    return ["ici.tou.tv"];
  }

  get UieBaseAddress(): string {
    return "https://uie.tou.tv";
  }

  get WebSessionLengthInMinutes(): number {
    return 6 * 60; // 6 hours
  }

  get SiteName(): string {
    return "tou.tv";
  }
}
